@for (brand of brands; track brand) {
  <button (click)="onBrandSwitch(brand.name)">
    <img src="assets/img/{{brand.icon}}"
      width="20"
      height="20"
      class="navbar-brand-img"
      alt="{{brand.name}}">
  </button>
}
